import { render, staticRenderFns } from "./IDCardUpload.vue?vue&type=template&id=3b3ac11f&scoped=true&"
import script from "./IDCardUpload.vue?vue&type=script&lang=js&"
export * from "./IDCardUpload.vue?vue&type=script&lang=js&"
import style0 from "./IDCardUpload.vue?vue&type=style&index=0&id=3b3ac11f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ac11f",
  null
  
)

export default component.exports